import gql from 'graphql-tag';

const sendEmailMutation = gql`
  mutation sendEmailMutation($shoppingCart: ShoppingCartInput!) {
    sendEmail(shoppingCart: $shoppingCart)
  }
`;

export default sendEmailMutation;
